<template>
	<div :class="[$style.logo, $style[color]]">
		<div>
			<div :class="[$style.title, $style[color]]">
				{{ name }}
			</div>
			<div :class="[$style.subtitle, $style[color]]">
				Ver: {{ version }}
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'GProjectLogo',
	props: {
		dark: {
			type: Boolean,
			default: null
		}
	},
	computed: {
		color() {
			let color = 'white';
			if (this.dark === null) {
				color = this.$settings.dark ? 'dark' : 'white';
			} else {
				color = this.dark ? 'dark' : 'white';
			}

			return color;
		},
		icon() {
			if (this.$settings.custom && this.$settings.custom.icon !== undefined) {
				return this.$settings.custom.icon;
			}
			return ['fad', 'rocket'];
		},
		name() {
			if (this.$settings.custom && this.$settings.custom.name !== undefined) {
				return this.$settings.custom.name;
			}
			return this.project;
		},
		project() {
			return this.$app.name;
		},
		version() {
			return this.$app.version;
		}
	}
};
</script>

<style lang="scss" module>
.logo {
	display: inline-flex;
	align-items: center;
}

.title {
	font-size: 21px;
	font-weight: bold;
	text-transform: uppercase;
	line-height: 21px;
	color: $dark;
}

.title.dark {
	color: $white;
}

.subtitle {
	font-size: 13px;
}

.subtitle.dark {
	color: $gray-2;
}
</style>
